
export class Rect {
  constructor(ctx, color, x, y, width, height) {
    this.ctx = ctx;
    this.color = color;
    this._x = x;
    this._y = y;
    this._width = width || x + 1;
    this._height = height || y + 1;
  }

  ctx;

  color;

  _x;

  _y;

  _width;

  _height;

  get x() {
    if (this._width < 0) return this._x + this._width;
    return this._x;
  }

  get y() {
    if (this._height < 0) return this._y + this._height;
    return this._y;
  }

  get width() {
    return Math.abs(this._width);
  }

  get height() {
    return Math.abs(this._height);
  }

  draw = () => {
    this.ctx.strokeStyle = this.color;
    this.ctx.strokeRect(this._x, this._y, this._width, this._height);
  };

  update(x, y) {
    this._width = x - this._x;
    this._height = y - this._y;
  }
}
